import type { AppModule } from '@/app/app-module.types';
import { DeliveryIcon } from '@/shared/icons';
import { ADMINISTRATOR } from '@/shared/guards/roles';
import { deliveryContainer } from './di/container';
import { DeliveryRepositoryToken } from './di/tokens';
import { deliveryRoutes } from './presentation/routes';

/**
 * Módulo de Entregas (Delivery Admin). Consome a área de leitura do módulo
 * `delivery` do monolith (`/admin/delivery/*`). Aparece no grupo "Gerenciamento"
 * da sidebar, só para `ADMINISTRATOR`.
 */
export const deliveryModule: AppModule = {
  name: 'delivery',

  register(container) {
    container.register(
      DeliveryRepositoryToken,
      () => deliveryContainer.repository,
    );
  },

  routes: deliveryRoutes,

  menu: [
    {
      label: 'Entregas',
      to: '/delivery',
      icon: DeliveryIcon,
      section: 'commercial',
      order: 3,
      roles: [ADMINISTRATOR],
    },
  ],
};
